<div class="flex-container">
  <div *ngFor="let participant of data; let i = index">
    <mat-accordion>
      <mat-expansion-panel [disabled]="!visibleForAdminOrShiftOrg()">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <table>
              <tr>
                <!--Checkmark presence-->
                <th *ngIf="visibleForAdminOrShiftOrg() && isAdminViewMode()" rowspan="2" style="
                                  border-right: 1px solid rgb(63, 62, 62);
                                  padding-right: 20px;
                                ">
                  <mat-checkbox [checked]="participant.present" [disabled]="!eventNotProcessed()" color="primary"
                    matTooltip="Anwesend/Abwesend setzen" (click)="$event.stopPropagation()"
                    (change)="onChangePresence($event, participant)">
                  </mat-checkbox>
                </th>

                <!--Person icon and name-->
                <td style="text-align: center;">
                  <mat-icon matPrefix>person</mat-icon>
                </td>
                <td style="vertical-align: middle;">{{ participant.firstName }} {{ participant.lastName }}</td>
              </tr>

              <!--Presence time-->
              <tr *ngIf="visibleForAdminOrShiftOrg()" style="text-align: center;">
                <td style="vertical-align: middle;">
                  <mat-icon>access_time</mat-icon>
                </td>
                <td style="text-align: left;">
                  {{ participant.start?.seconds * 1000 | date : "H:mm" }} -
                  {{ participant.end?.seconds * 1000 | date : "H:mm" }}
                </td>
              </tr>
            </table>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <mat-divider></mat-divider>

        <table style="margin-top: 20px">
          <tr>
            <td>
              <mat-form-field style="width: 90%">
                <mat-label>Startdatum</mat-label>
                <input matInput [matDatepicker]="startDatePicker"
                  [value]="asDate(participant?.start)"
                  [min]="asDate(workPackage?.start)"
                  [max]="asDate(workPackage?.end)"
                  [disabled]="event?.processedInBackend"
                  (dateChange)="startDateChanged($event, participant)">
                <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #startDatePicker></mat-datepicker>
              </mat-form-field>
            </td>
          </tr>
          <tr>
            <td>
              <mat-form-field style="width: 90%">
                <input matInput [ngxTimepicker]="startTimePicker"
                  [format]="24"
                  [value]="formatTime(participant?.start)"
                  [disabled]="event?.processedInBackend"
                  placeholder="Startzeit">
                <mat-icon matSuffix>access_time</mat-icon>
                <ngx-material-timepicker #startTimePicker [hoursOnly]="true"
                  [defaultTime]="formatTime(participant?.start)"
                  (timeSet)="startTimeChanged($event, participant)"></ngx-material-timepicker>
              </mat-form-field>
            </td>
          </tr>
          <tr>
            <td>
              <mat-form-field style="width: 90%">
                <mat-label>Enddatum</mat-label>
                <input matInput [matDatepicker]="endDatePicker"
                  [value]="asDate(participant?.end)"
                  [min]="asDate(workPackage?.start)"
                  [max]="asDate(workPackage?.end)"
                  [disabled]="event?.processedInBackend"
                  (dateChange)="endDateChanged($event, participant)">
                <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #endDatePicker></mat-datepicker>
              </mat-form-field>
            </td>
          </tr>
          <tr>
            <td>
              <mat-form-field style="width: 90%">
                <input matInput [ngxTimepicker]="endTimePicker"
                  [format]="24"
                  [value]="formatTime(participant?.end)"
                  [disabled]="event?.processedInBackend"
                  placeholder="Endzeit">
                <mat-icon matSuffix>access_time</mat-icon>
                <ngx-material-timepicker #endTimePicker [hoursOnly]="true"
                  [defaultTime]="formatTime(participant?.end)"
                  (timeSet)="endTimeChanged($event, participant)"></ngx-material-timepicker>
              </mat-form-field>
            </td>
          </tr>
          <tr>
            <td>
              <button mat-raised-button style="width: 90%" color="warn" matTooltip="Teilnehmer entfernen"
                (click)="removeParticipant(participant)" *ngIf="visibleForAdminOrShiftOrg()"
                [disabled]="event?.processedInBackend">
                Teilnehmer entfernen
              </button>
            </td>
          </tr>
        </table>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>